import { t } from "i18next";

import { ESegmentAppStatus, SegmentDefinition } from "../marketing.types";

export const describeSegment = (definition: SegmentDefinition): string => {
  const parts: string[] = [];

  if (definition.appStatus === ESegmentAppStatus.Installed) {
    parts.push(t("App installed"));
  }

  if (definition.appStatus === ESegmentAppStatus.NotInstalled) {
    parts.push(t("No app"));
  }

  if (definition.hasOrdered === true) {
    parts.push(t("Has ordered"));
  }

  if (definition.hasOrdered === false) {
    parts.push(t("Never ordered"));
  }

  if (definition.minOrders !== undefined) {
    parts.push(`≥ ${definition.minOrders} ${t("orders")}`);
  }

  if (definition.minTotalSpend !== undefined) {
    parts.push(`≥ ${definition.minTotalSpend.toLocaleString()} FCFA`);
  }

  if (definition.boughtProductVariantIds?.length) {
    parts.push(
      `${t("Bought")} ${definition.boughtProductVariantIds.length} ${t(
        "product(s)"
      )}`
    );
  }

  if (definition.boughtCategoryIds?.length) {
    parts.push(
      `${t("Bought in")} ${definition.boughtCategoryIds.length} ${t(
        "category(ies)"
      )}`
    );
  }

  if (definition.inactiveForDays !== undefined) {
    parts.push(`${t("Inactive")} ${definition.inactiveForDays}+ ${t("days")}`);
  }

  return parts.length ? parts.join(" · ") : t("All contacts");
};
